<template>
  <div class="contentHome">
    <div class="centerPage">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
        <el-breadcrumb-item>
          <a href="javascript:void(0);" @click="$router.push('/lecture')" class="aHref">专家讲座</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>讲座详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="newLect flex">
        <div class=" img" :style="'backgroundImage: url('+details.thumbnailPath+')'"></div>
        <div class="rightC">
          <h1 class="overflow">{{ details.title }}</h1>
          <div class="program">
            <p><label class="line"></label>{{ details.subTitle }}</p>
          </div>
          <div class="endTime">
            <span>{{ details.registerCount }}人已报名</span>
            <span>{{ details.deadlineDate }} 截止报名</span>
          </div>
        </div>
      </div>
      <div class="detailCon">
        <div class="indicationsTit">
          <span class="tit">讲座介绍</span>
          <p>{{ details.briefDesc }}</p>
        </div>
        <div class="indicationsTit">
          <span class="tit">讲座专家</span>
          <div class="expert flex">
            <div class="swiperImg flex doctor-item" v-for="(item,index) in details.doctors" :key="index"
                 @click="toDoctorDetails(item)">
              <div :style="'backgroundImage: url('+item.headImgPath+')'" class="img"></div>
              <div class="ri">
                <strong>{{ item.fullName }}</strong><br/>
                <span>咨询专长：{{ item.indications | indicationFmt }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="indicationsTit">
          <span class="tit">讲座时间</span>
          <p>{{ details | dateFmt }}</p>
        </div>
        <div class="indicationsTit">
          <span class="tit">讲座说明</span>
          <p>{{ details.explanation }}</p>
        </div>
      </div>
      <el-button class="joinUs" :disabled="state!=0" :data-type="state" @click="toJoin">{{ stateText }}</el-button>
    </div>
  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "lectureDetail",
  data() {
    return {
      id: this.$route.query.id,
      details: {},

      isRegistered: 0,
      stateText: '',
      state: 0,
    }
  },
  mounted() {
    if (this.id) {
      this.$ajax.get(base.api.expert.lecture.details_auth.replace("{id}", this.id)).then((res) => {
        if (res.data.status === 'success') {
          this.details = res.data.data;
          this.handleJoinBtn(res.data.isRegistered);
        }
      }).catch((err) => {
        // 未登录
        if (err.response.status === 401) {
          this.$ajax.get(base.api.expert.lecture.details_anyone.replace("{id}", this.id)).then((res) => {
            if (res.data.status === 'success') {
              this.details = res.data.data;
              this.handleJoinBtn(0);
            }
          })
        }
      })
    }
  },
  methods: {
    handleJoinBtn(isRegistered) {
      if (this.details.id) {
        let item = this.details;
        //item
        let s = new Date(item.startDate.replace(/-/g, "/"));
        let e = new Date(item.endDate.replace(/-/g, "/"));
        let de = new Date(item.deadlineDate.replace(/-/g, "/"));
        let cur = new Date();

        this.stateText = "已结束";
        if (de.getTime() <= cur.getTime()) {
          this.stateText = "已截止报名";
          this.state = 3;
        }
        if (e.getTime() <= cur.getTime()) {
          this.state = 3;
          this.stateText = "已结束";
          return;
        }

        if (s.getTime() > cur.getTime()) {
          if (isRegistered && isRegistered === 1) {
            this.stateText = "已报名";
            this.state = 2;
          } else {

            if (item.maxRegisterCount && item.registerCount && item.maxRegisterCount <= item.registerCount) {
              this.stateText = "名额已满";
              this.state = 3;
            }

            this.stateText = "立即加入";
            this.state = 0;
          }
        }
        if (s.getTime() <= cur.getTime() && e.getTime() >= cur.getTime()) {
          this.stateText = "授课中";
          this.state = 1;
          return;
        }
      }
    },
    toJoin() {
      this.$router.push({name: 'lectureSignUp', query: {id: this.id}})
    },
    toDoctorDetails(doctor) {
      if (doctor && doctor.account) {
        this.$router.push({path: "/" + doctor.account})
      }
    }
  },
  filters: {
    dateFmt(item) {
      if (item.startDate && item.endDate) {
        let s = new Date(item.startDate.replace(/-/g, "/"));
        let e = new Date(item.endDate.replace(/-/g, "/"));

        return s.Format("yyyy年MM月dd日 HH:mm:ss") + " - " + e.Format("yyyy年MM月dd日 HH:mm:ss");
      }
      return "-";
    },
    indicationFmt(indications) {
      if (indications && indications.length > 0) {
        let arr = [];
        $(indications).each((i, o) => {
          arr.push(o.cnName);
        })
        return arr.join("、");
      }
      return "";
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/medication.scss';

.newCon {
  margin-top: 20px;
}

.endTime {
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #656565;

  span:last-child {
    color: #FB7B65;
  }
}

.joinUs[data-type='1'], .joinUs[data-type='1']:hover {
  color: #fff;
  background-color: #FFAD57;
  border-color: #FFAD57;
}

.joinUs[data-type='2'], .joinUs[data-type='2']:hover {
  color: #fff;
  background-color: #f56c6c;
  border-color: #f56c6c;
}

.joinUs[data-type='3'], .joinUs[data-type='3']:hover {
  color: #fff;
  background-color: #909399;
  border-color: #909399;
}

.doctor-item {
  cursor: pointer
}
</style>
